import { render, staticRenderFns } from "./JoinSharedEmailAddress.vue?vue&type=template&id=72452a4e&scoped=true&"
import script from "./JoinSharedEmailAddress.vue?vue&type=script&lang=ts&"
export * from "./JoinSharedEmailAddress.vue?vue&type=script&lang=ts&"
import style0 from "./JoinSharedEmailAddress.vue?vue&type=style&index=0&id=72452a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72452a4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
